var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-page"},[_c('div',{staticClass:"alfa"},[_c('div',{staticClass:"message-content"},[_c('content-message')],1),_c('div'),_vm._v(" "),_c('div')]),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }